import { render, staticRenderFns } from "./IconDeur.vue?vue&type=template&id=bf6a04aa"
import script from "./IconDeur.vue?vue&type=script&lang=ts"
export * from "./IconDeur.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports